"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _tooltip = _interopRequireDefault(require("./tooltip"));
var _configContext = require("../../config-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const List = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "List",
  class: "pl-l3dcxhc"
});
const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-w1xuc0s8"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconWrapper",
  class: "pl-i1pdbsoy"
});

/**
 * ListItem Component.
 *
 * @param {Object} props React props
 * @param {String} props.id Unique id of the child element
 * @param {String} props._name Tracking Click Event
 * @param {Number} props.i Index of the item
 * @param {String} props.iconType Tyoe of the icon
 * @param {String} props.content Text to displayed
 * @param {Boolean} props.expanded Open | Close Condition
 * @param {Function} props.setExpanded Forwarded Function to set expanded state
 * @param {Object} props.image Image to display
 * @param {String} props.tooltipText Text to display in the tooltip
 * @returns {React.ReactElement} ListItem Component
 * @public
 */

function ListItem({
  id,
  _name,
  i,
  iconType,
  content,
  expanded,
  setExpanded,
  image,
  tooltipText,
  ...rest
}) {
  const [tooltipPos, setTooltipPos] = (0, _react.useState)({
    left: 0,
    top: 0
  });
  const config = (0, _react.useContext)(_configContext.ConfigContext);
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const [isReady, setIsReady] = (0, _react.useState)(true);
  const [isLazyLoaded, setIsLazyLoaded] = (0, _react.useState)(false);
  const textRef = (0, _react.useRef)(null);
  const tooltipRef = (0, _react.useRef)(null);
  const iconComponent = iconType ? /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: iconType
  }) : /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: "circle-filled",
    width: "0.5rem",
    height: "0.5rem"
  });
  const plusIcon = /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: "plus"
  });
  if (image) image.loading = 'manual';
  const handleTouchEnd = () => {
    setTimeout(() => {
      setIsReady(true);
    }, 500);
    if (isReady) {
      loadNavImages();
      setExpanded(expanded ? null : i);
    }
  };
  const handleMouseEnter = () => {
    loadNavImages();
    setExpanded(expanded ? null : i);
  };
  const handleClose = () => {
    setExpanded(false);
  };
  (0, _react.useEffect)(() => {
    const textElement = textRef.current;
    const tooltipElement = tooltipRef.current;
    if (!textElement || !tooltipElement) return;
    const textRect = textElement.getBoundingClientRect();
    const tooltipRect = tooltipElement.getBoundingClientRect();
    const arrowOffset = 20;
    const isImageRight = config?.layout === 'image-right';
    setTooltipPos({
      left: isImageRight ? textRect.right : -tooltipRect.width - arrowOffset,
      top: textRect.height / 2
    });
  }, [config, width]);
  function loadNavImages() {
    if (!isLazyLoaded && image) {
      image.show = true;
      setIsLazyLoaded(true);
    }
  }
  const ListElement = tooltipText ? List : 'li';
  const handleMouseEvents = width >= _patternLibraryUtils.size.laptop && tooltipText ? {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleClose
  } : null;
  return /*#__PURE__*/_react.default.createElement(ListElement, (0, _extends2.default)({
    id: `id-${id}`,
    "data-cy": "rtb-list-item",
    tabIndex: "0",
    onMouseEnter: handleMouseEvents?.onMouseEnter,
    onMouseLeave: handleMouseEvents?.onMouseLeave,
    onClick: handleTouchEnd,
    onKeyDown: ({
      key
    }) => {
      if (key === 'Enter') {
        setExpanded(expanded ? null : i);
      }
    }
  }, _patternLibraryUtils.tracking.create(_name, true, true)), /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(IconWrapper, {
    "data-cy": "rtb-list-item-icon"
  }, iconComponent), /*#__PURE__*/_react.default.createElement("span", {
    ref: textRef,
    className: "list-item-text"
  }, /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "paragraph",
    "data-cy": "rtb-list-item-text",
    size: 1,
    className: "rtb-list-item-text"
  }, content)), tooltipText ? /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    className: "icon-plus plus"
  }, plusIcon) : null), tooltipText ? /*#__PURE__*/_react.default.createElement(_tooltip.default, (0, _extends2.default)({
    setIsOpen: handleClose,
    content: content,
    isOpen: expanded,
    image: image,
    tooltipText: tooltipText,
    position: tooltipPos,
    tooltipRef: tooltipRef
  }, rest)) : null);
}
var _default = exports.default = ListItem;
ListItem.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  i: _propTypes.default.number,
  iconType: _propTypes.default.string,
  content: _propTypes.default.string,
  tooltipText: _propTypes.default.string,
  forwardedRef: _propTypes.default.object,
  expanded: _propTypes.default.bool,
  setExpanded: _propTypes.default.func,
  image: _propTypes.default.object
};